import { createEnumFromArray } from '@cloud-wave/neon-common-lib';

const IQDisplayModes = ['COMPACT', 'COMFORTABLE', 'STAND_ALONE'] as const;
export type TIQDisplayMode = (typeof IQDisplayModes)[number];

export const IQDisplayMode = createEnumFromArray(IQDisplayModes);
